import { render } from "./TopStylistPerformance.vue?vue&type=template&id=628c149f&scoped=true&ts=true"
import script from "./TopStylistPerformance.vue?vue&type=script&lang=ts"
export * from "./TopStylistPerformance.vue?vue&type=script&lang=ts"

import "./TopStylistPerformance.vue?vue&type=style&index=0&id=628c149f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628c149f"]])

export default __exports__